// extracted by mini-css-extract-plugin
export var bodyRow = "_fn-d";
export var cardColumns = "_fn-e";
export var ellipsesOverflow = "_fn-2";
export var flatBottomCorners = "_fn-3";
export var flatTopCorners = "_fn-4";
export var headerActionsDropdown = "_fn-f";
export var headerBottomRow = "_fn-c";
export var headerTopRow = "_fn-b";
export var orderDetailsWrapper = "_fn-0";
export var orderInfoContainer = "_fn-1";
export var productDetails = "_fn-9";
export var productImage = "_fn-5";
export var responsiveTable = "_fn-8";
export var shipmentContainer = "_fn-a";
export var tableBottomLeft = "_fn-6";
export var tableBottomRight = "_fn-7";
export var trackingLink = "_fn-g";